import { Application } from '../../blocks/common/components/application';
import { ProductTutorialVideos } from '../../blocks/pages/video-tutorials/product-tutorial-videos';


class Main extends Application {
    async init() {
        await super.init();

        const productTutorialVideos = new ProductTutorialVideos();
        const productTutorialVideosOptions = {
            store: this.store,
            selector: '.product-tutorial-videos',
        };
        productTutorialVideos.init(productTutorialVideosOptions);
    }
}

const application = new Main();
application.init();
window['application'] = application;